var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable no-underscore-dangle */
import { Component, Mixins, Watch } from 'vue-property-decorator';
import { startMouseMove } from "../../../../lib/utils";
import { elt } from "../../../../lib/utils/browser";
import { concatStorageKey, vueLinkLocalStorage } from "../../../../lib/utils/vue/vueLinkLocalStorage";
import devToolMixin from '../util/devToolMixin';
let interval;
const highlightBoxCSS = 'pointer-events: none; color: white; position: fixed; background: rgba(66,185,131, 0.5); border-radius: 4px; transition: opacity 0.3s linear 1s; opacity: 1; z-index: 10001;';
const textCSS = 'min-width: max-content; position: absolute; color: white; font-weight: bold; font-size: 15px; background-color: black; padding: 0 5px;';
let highlightBox;
export function hoverHighlightRect(vue) {
  var _vue$$el, _vue$$options, _vue$$el2;
  const rect = (vue === null || vue === void 0 || (_vue$$el = vue.$el) === null || _vue$$el === void 0 ? void 0 : _vue$$el.getBoundingClientRect()) || null;
  const name = ((_vue$$options = vue.$options) === null || _vue$$options === void 0 ? void 0 : _vue$$options.name) || 'unknown';
  if (!rect) return;
  const {
    left,
    top,
    width,
    height
  } = rect;
  if (highlightBox) {
    window.document.body.removeChild(highlightBox);
  }
  highlightBox = window.document.createElement('div');
  const text = window.document.createElement('span');
  text.innerHTML = `${name} <span style="font-size: 12px; color: #f0f0f0; text-align: center;"> ${width.toFixed()} x ${height.toFixed()} </span>`;
  text.setAttribute('style', `margin-top: ${((vue === null || vue === void 0 || (_vue$$el2 = vue.$el) === null || _vue$$el2 === void 0 || (_vue$$el2 = _vue$$el2.getBoundingClientRect()) === null || _vue$$el2 === void 0 ? void 0 : _vue$$el2.top) || 0) < 30 ? '0px' : '-23px'}; ${textCSS}`);
  highlightBox.appendChild(text);
  highlightBox.setAttribute('style', `left: ${left}px; top: ${top}px; width: ${width}px; height: ${height}px;${highlightBoxCSS}`);
  window.document.body.appendChild(highlightBox);
}
let WindowPortal = class WindowPortal extends Mixins(devToolMixin) {
  constructor() {
    super(...arguments);
    this.hoverTarget = null;
    this.dummyParent = null;
    this.iframe = null;
    this.pageElement = null;
    this.observer = null;
    this.extraWidth = 0;
    this.dockWidth = 300;
    this.dockHeight = 300;
    this.extraHeight = 0;
  }
  openPortal() {
    this.windowRef = window.open('', 'DevTool', Object.entries(this.windowOptions).map(option => `${option[0]}=${option[1]}`).join(','));
    if (!window.name) window.name = 'DevToolParent'; // 可能会被覆盖
    if (!this.windowRef) return;
    this.windowRef.document.title = 'DevTool';
    this.windowRef.document.body.innerHTML = '';
    this.windowRef.document.body.appendChild(this.$el);
    this.copyStyles(window.document, this.windowRef.document);
    window.addEventListener('beforeunload', () => {
      this.closePortal();
    });
    this.windowRef.addEventListener('beforeunload', () => {
      this.closePortal();
    });
    this.bus.textarea = this.windowRef.document.createElement('textarea');
    this.bus.textarea.setAttribute('style', 'position:fixed;left:0;top:0;opacity:0.01;width:5px;height:10px;');
    this.windowRef.resizeTo(this.windowOptions.width, this.windowOptions.height);
    this.windowRef.moveTo(this.windowOptions.left, this.windowOptions.top);
    this.windowRef.addEventListener('resize', this.handleResizeWindow);
    this.windowRef.addEventListener('mouseout', this.handleMoveWindow);
    this.bus.beginListening();
  }
  get localStorageKey() {
    return concatStorageKey('windowPortal', 'devToolSize');
  }
  handleMoveWindow(e) {
    if (e.toElement === null && e.relatedTarget === null) {
      interval = setInterval(() => {
        var _this$windowRef, _this$windowRef2;
        this.windowOptions = {
          ...this.windowOptions,
          left: (_this$windowRef = this.windowRef) === null || _this$windowRef === void 0 ? void 0 : _this$windowRef.screenX,
          top: (_this$windowRef2 = this.windowRef) === null || _this$windowRef2 === void 0 ? void 0 : _this$windowRef2.screenY
        };
      }, 250);
    } else {
      clearInterval(interval);
    }
  }
  handleResizeWindow() {
    this.windowOptions = {
      ...this.windowOptions,
      width: this.windowRef.innerWidth,
      height: this.windowRef.innerHeight
    };
  }
  handleDarkMode(val) {
    this.$nextTick(() => {
      var _this$windowRef3;
      const roots = (_this$windowRef3 = this.windowRef) === null || _this$windowRef3 === void 0 ? void 0 : _this$windowRef3.document.getElementsByClassName('ucd-devTool');
      if (!roots || (roots === null || roots === void 0 ? void 0 : roots.length) !== 1) return;
      const root = roots[0];
      if (val) {
        root === null || root === void 0 || root.classList.add('dt-darkMode');
      } else {
        root === null || root === void 0 || root.classList.remove('dt-darkMode');
      }
    });
  }
  closePortal() {
    var _this$windowRef4, _this$observer;
    this.bus.options.capturing = false;
    try {
      this.windowRef.removeEventListener('resize', this.handleResizeWindow);
      this.windowRef.removeEventListener('mouseout', this.handleMoveWindow);
    } catch (e) {}
    (_this$windowRef4 = this.windowRef) === null || _this$windowRef4 === void 0 || _this$windowRef4.close();
    this.windowRef = null;
    this.bus.cleanBus();
    this.open = false;
    (_this$observer = this.observer) === null || _this$observer === void 0 || _this$observer.disconnect();
    try {
      this.container.removeChild(this.dummyParent);
    } catch (e) {}
  }
  get open() {
    return this.bus.options.open;
  }
  set open(val) {
    this.bus.$set(this.bus.options, 'open', val);
  }
  created() {
    vueLinkLocalStorage(this, 'UcDevTool', 'displayMode');
    vueLinkLocalStorage(this, 'UcDevTool', 'dockWidth');
    vueLinkLocalStorage(this, 'UcDevTool', 'dockHeight');
    this.$watch('displayMode', async (newVal, oldVal) => {
      if (this.windowRef) {
        try {
          this.pageElement.style[`padding-${oldVal}`] = '0px';
        } catch (e) {}
        this.closePortal();
      }
      this.open = false;
      await this.$nextTick();
      this.open = true;
    });
    this.$watch('open', () => {
      if (this.open) this.openDockDevTool();else this.closePortal();
    }, {
      immediate: true
    });
    this.$watch('isDesignMode', () => {
      this.closePortal();
    }, {
      immediate: true
    });
  }
  openDockDevTool() {
    var _this$container, _this$container2, _this$container3, _this$container4, _this$container5, _this$container6;
    if (this.displayMode === 'seperate') {
      this.openPortal();
      return;
    }
    if (!this.$el) return;
    this.bus.beginListening();
    try {
      this.container.removeChild(this.dummyParent);
    } catch (e) {}
    this.iframe = elt('iframe', {
      style: 'border:unset;',
      frameborder: '0',
      width: '100%'
    });
    let top = 0;
    // 计算 iframe 的高度，在uicore和xy的各个模式中，iframe的高度不一样
    if (this.isXY) {
      if (this.showJump) {
        this.container = document.querySelector('#xy-runtime-wrap');
        this.iframe.style.height = 'calc(100vh - 56px)';
        top = 56;
      } else {
        this.container = document.querySelector('#w-sys-content');
        this.iframe.style.height = 'calc(100vh - 5px)';
        top = 5;
      }
    } else {
      // this.iframe.style.height = 'calc(100vh - 100px)';
      this.iframe.style.height = '100%';
      this.container = document.querySelector(this.isDesignMode ? '.designerCard' : '.previewCard');
    }
    if (!this.container) {
      this.displayMode = 'seperate';
      return;
    }
    const resizer = elt('div', {
      class: `ucd-devTool-dock-resizer ${this.displayMode}`,
      onmousedown: this.startResize
    });
    // 将iframe插入到container中
    switch (this.displayMode) {
      case 'right':
        this.dummyParent = elt('div', {
          style: `right:0;top:${top}px;position:fixed;width:50px;height: 100%; z-index:10;`
        }, [resizer, this.iframe]);
        this.pageElement = (_this$container = this.container) === null || _this$container === void 0 ? void 0 : _this$container.lastElementChild;
        this.syncDockWidth();
        (_this$container2 = this.container) === null || _this$container2 === void 0 || _this$container2.appendChild(this.dummyParent);
        break;
      case 'left':
        this.dummyParent = elt('div', {
          style: `left: 0; top: ${top}px; position: fixed; width: 50px; height: 100%; z-index: 10;`
        }, [this.iframe, resizer]);
        this.pageElement = (_this$container3 = this.container) === null || _this$container3 === void 0 ? void 0 : _this$container3.firstElementChild;
        this.syncDockWidth();
        (_this$container4 = this.container) === null || _this$container4 === void 0 || _this$container4.insertBefore(this.dummyParent, this.pageElement);
        break;
      case 'bottom':
        this.iframe.style.height = '100%';
        this.dummyParent = elt('div', {
          style: 'left:0;bottom:0;position:fixed;width:100vw; height: 300px; z-index:10;max-height:80vh;'
        }, [resizer, this.iframe]);
        this.pageElement = (_this$container5 = this.container) === null || _this$container5 === void 0 ? void 0 : _this$container5.firstElementChild;
        this.syncDockWidth();
        (_this$container6 = this.container) === null || _this$container6 === void 0 || _this$container6.appendChild(this.dummyParent);
        break;
    }
    // 将devTool内容插入到iframe中
    const iwindow = this.iframe.contentWindow;
    this.windowRef = iwindow;
    const idoc = iwindow.document;
    idoc.body.innerHTML = '';
    idoc.body.appendChild(this.$el);
    this.observer = new ResizeObserver(entries => {
      const entry = entries[0];
      if (entry) {
        switch (this.displayMode) {
          case 'left':
            this.pageElement.style['padding-left'] = `${entry.contentRect.width}px`;
            break;
          case 'right':
            this.pageElement.style['padding-right'] = `${entry.contentRect.width}px`;
            break;
          case 'bottom':
            this.pageElement.style['padding-bottom'] = `${entry.contentRect.height}px`;
        }
      }
    });
    if (this.dummyParent) this.observer.observe(this.dummyParent);
    this.copyStyles(window.document, idoc);
  }
  syncDockWidth() {
    switch (this.displayMode) {
      case 'left':
        this.dummyParent.style.width = `${this.dockWidth + this.extraWidth}px`;
        break;
      case 'right':
        this.dummyParent.style.width = `${this.dockWidth - this.extraWidth}px`;
        break;
      case 'bottom':
        this.dummyParent.style.height = `${this.dockHeight - this.extraHeight}px`;
        break;
    }
  }
  startResize(e) {
    this.iframe.style.pointerEvents = 'none';
    startMouseMove({
      initialEvent: e,
      onMove: ({
        deltaX,
        deltaY
      }) => {
        if (this.displayMode === 'bottom') {
          this.extraHeight = deltaY;
        } else {
          this.extraWidth = deltaX;
        }
        this.syncDockWidth();
        if (this.showJump && this.isXY) {
          if (this.displayMode === 'right') {
            document.documentElement.scrollLeft += Math.abs(deltaX);
          } else if (this.displayMode === 'left') {
            document.documentElement.scrollLeft = 0;
          }
        }
      },
      onEnd: () => {
        if (this.displayMode === 'bottom') {
          this.dockHeight = this.dockHeight - this.extraHeight;
          this.extraHeight = 0;
        } else {
          this.dockWidth = this.displayMode === 'left' ? this.dockWidth + this.extraWidth : this.dockWidth - this.extraWidth;
          this.extraWidth = 0;
        }
        this.iframe.style.pointerEvents = 'auto';
      }
    });
  }
  beforeDestroy() {
    clearInterval(interval);
    this.closePortal();
  }
  copyStyles(sourceDoc, targetDoc) {
    Array.from(sourceDoc.styleSheets).forEach(styleSheet => {
      try {
        var _styleSheet$ownerNode;
        if (styleSheet.cssRules && ((_styleSheet$ownerNode = styleSheet.ownerNode) === null || _styleSheet$ownerNode === void 0 ? void 0 : _styleSheet$ownerNode.tagName) === 'STYLE') {
          const newStyleEl = sourceDoc.createElement('style');
          Array.from(styleSheet.cssRules).forEach(cssRule => {
            newStyleEl.appendChild(sourceDoc.createTextNode(cssRule.cssText));
          });
          targetDoc.head.appendChild(newStyleEl);
        }
      } catch (e) {
        console.log(`cross origin styles detected: ${JSON.stringify(e)}`);
      } finally {
        var _styleSheet$ownerNode2;
        if (styleSheet.href && ((_styleSheet$ownerNode2 = styleSheet.ownerNode) === null || _styleSheet$ownerNode2 === void 0 ? void 0 : _styleSheet$ownerNode2.tagName) === 'LINK') {
          const newLinkEl = sourceDoc.createElement('link');
          newLinkEl.rel = 'stylesheet';
          newLinkEl.href = styleSheet.href;
          targetDoc.head.appendChild(newLinkEl);
        }
      }
    });
  }
  // 把捕获的逻辑放到这里，防止关闭的时候还残留着监听器
  async handleCaptureChange(val, oldVal) {
    if (val === oldVal) return;
    if (!val) {
      var _this$windowRef5;
      (_this$windowRef5 = this.windowRef) === null || _this$windowRef5 === void 0 || _this$windowRef5.focus();
      this.clearCapture();
    } else {
      if (this.displayMode === 'seperate') {
        var _this$windowRef6, _this$windowRef7;
        const goBack = (_this$windowRef6 = this.windowRef) === null || _this$windowRef6 === void 0 ? void 0 : _this$windowRef6.open('', ((_this$windowRef7 = this.windowRef) === null || _this$windowRef7 === void 0 || (_this$windowRef7 = _this$windowRef7.opener) === null || _this$windowRef7 === void 0 ? void 0 : _this$windowRef7.name) || 'DevToolParent');
        goBack === null || goBack === void 0 || goBack.focus();
      }
      this.startCapture();
    }
    await this.$nextTick();
  }
  clearCapture() {
    window.document.removeEventListener('click', this.capture, {
      capture: true
    });
    window.document.removeEventListener('mousedown', this.muteClick, {
      capture: true
    });
    window.document.removeEventListener('mouseup', this.muteClick, {
      capture: true
    });
    window.document.removeEventListener('mouseover', this.hoverDocument);
    if (highlightBox) {
      window.document.body.removeChild(highlightBox);
      highlightBox = null;
    }
    window.document.body.style.setProperty('cursor', 'auto', 'important');
    this.hoverTarget = null;
  }
  capture(e) {
    if (!this.hoverTarget) return;
    e.stopPropagation();
    e.preventDefault();
    // 用户可能捕获了一个不再当前作用域的组件，需要更新scopedStack来切换作用域
    let renderer = this.hoverTarget.$vnode.data['uc:renderer'];
    const res = [];
    while ((_renderer = renderer) !== null && _renderer !== void 0 && _renderer.parentScope) {
      var _renderer;
      const prevCompPath = renderer.ucScopedSlotOwner.compPath;
      const scopeInfo = this.findScopeInfo(renderer.parentScope, prevCompPath, renderer);
      res.unshift(scopeInfo);
      renderer = renderer.parentScope;
    }
    const newCompPath = this.hoverTarget.$vnode.data['uc:path'];
    this.$set(this.bus, 'scopedSlotStack', res);
    this.$nextTick(() => {
      if (newCompPath !== undefined) this.activeCompPath = newCompPath;
    });
    this.bus.options.capturing = false;
  }
  muteClick(e) {
    e.stopPropagation();
    e.preventDefault();
  }
  startCapture() {
    // this.messageOnDt('请到主窗口选中组件');
    window.document.body.style.setProperty('cursor', 'crosshair', 'important');
    window.document.addEventListener('click', this.capture, {
      capture: true
    });
    window.document.addEventListener('mousedown', this.muteClick, {
      capture: true
    });
    window.document.addEventListener('mouseup', this.muteClick, {
      capture: true
    });
    window.document.addEventListener('mouseover', this.hoverDocument);
  }
  hoverDocument(e) {
    let {
      target
    } = e;
    // 找当前组件的父级vue
    let resultVue;
    // eslint-disable-next-line no-restricted-syntax
    searching: while (!!target) {
      let vue = target.__vue__;
      while (vue && vue.$el === target) {
        var _vue$$vnode;
        if ((_vue$$vnode = vue.$vnode) !== null && _vue$$vnode !== void 0 && _vue$$vnode.data['uc:path']) {
          resultVue = vue;
          break searching;
        }
        vue = vue.$parent;
      }
      target = target.parentElement;
    }
    if (!resultVue) return;
    hoverHighlightRect(resultVue);
    this.hoverTarget = resultVue;
  }
  render() {
    const h = arguments[0];
    if (!this.open) return h("div", [" "]);
    return h("div", {
      "class": "ucd-devTool",
      "style": {}
    }, [this.$slots.default]);
  }
};
__decorate([Watch('bus.options.darkMode')], WindowPortal.prototype, "handleDarkMode", null);
__decorate([Watch('bus.options.capturing')], WindowPortal.prototype, "handleCaptureChange", null);
WindowPortal = __decorate([Component({
  name: 'WindowPortal'
})], WindowPortal);
export default WindowPortal;